module.exports = __webpack_public_path__ + "static/media/klauzura.92862d97.jpg";